import { json } from "@sveltejs/kit";
import { unlink } from "fs/promises";
import { join } from "path";
import { homedir } from "os";
const PANELS_DIR = join(homedir(), "morphbox", "panels");
const DELETE = async ({ params, url }) => {
  try {
    const panelId = url.searchParams.get("id");
    if (!panelId) {
      return json({ error: "Panel ID is required" }, { status: 400 });
    }
    const sanitizedId = panelId.replace(/[^a-zA-Z0-9-]/g, "");
    if (sanitizedId !== panelId) {
      return json({ error: "Invalid panel ID" }, { status: 400 });
    }
    const morphFile = join(PANELS_DIR, `${panelId}.morph`);
    const svelteFile = join(PANELS_DIR, `${panelId}.svelte`);
    const metadataFile = join(PANELS_DIR, `${panelId}.json`);
    if (!morphFile.startsWith(PANELS_DIR) || !svelteFile.startsWith(PANELS_DIR) || !metadataFile.startsWith(PANELS_DIR)) {
      return json({ error: "Invalid file path" }, { status: 403 });
    }
    console.log(`[DELETE] Attempting to delete panel: ${panelId}`);
    console.log(`[DELETE] Morph file: ${morphFile}`);
    console.log(`[DELETE] Legacy svelte file: ${svelteFile}`);
    console.log(`[DELETE] Legacy metadata file: ${metadataFile}`);
    const errors = [];
    try {
      await unlink(morphFile);
      console.log(`[DELETE] Successfully deleted: ${morphFile}`);
    } catch (error) {
      if (error.code !== "ENOENT") {
        console.error(`[DELETE] Failed to delete morph file:`, error);
        errors.push(`Failed to delete panel file: ${error.message}`);
      } else {
        console.log(`[DELETE] Morph file not found, checking legacy formats...`);
      }
    }
    try {
      await unlink(svelteFile);
      console.log(`[DELETE] Successfully deleted legacy: ${svelteFile}`);
    } catch (error) {
      if (error.code !== "ENOENT") {
        console.error(`[DELETE] Failed to delete svelte file:`, error);
        errors.push(`Failed to delete panel file: ${error.message}`);
      }
    }
    try {
      await unlink(metadataFile);
      console.log(`[DELETE] Successfully deleted legacy: ${metadataFile}`);
    } catch (error) {
      if (error.code !== "ENOENT") {
        console.error(`[DELETE] Failed to delete metadata file:`, error);
        errors.push(`Failed to delete metadata file: ${error.message}`);
      }
    }
    if (errors.length > 0) {
      return json({
        error: "Partial deletion failure",
        details: errors
      }, { status: 500 });
    }
    return json({
      success: true,
      message: `Panel ${panelId} deleted successfully`
    });
  } catch (error) {
    console.error("Failed to delete custom panel:", error);
    let errorMessage = "Failed to delete panel";
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    return json({ error: errorMessage }, { status: 500 });
  }
};
export {
  DELETE
};
